var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewleads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74922 5.435C4.69922 5.43 4.63922 5.43 4.58422 5.435C3.39422 5.395 2.44922 4.42 2.44922 3.22C2.44922 1.995 3.43922 1 4.66922 1C5.89422 1 6.88922 1.995 6.88922 3.22C6.88422 4.42 5.93922 5.395 4.74922 5.435Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37359 2C9.34359 2 10.1236 2.785 10.1236 3.75C10.1236 4.695 9.37359 5.465 8.43859 5.5C8.39859 5.495 8.35359 5.495 8.30859 5.5",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24734 7.28C1.03734 8.09 1.03734 9.41 2.24734 10.215C3.62234 11.135 5.87734 11.135 7.25234 10.215C8.46235 9.405 8.46235 8.085 7.25234 7.28C5.88234 6.365 3.62734 6.365 2.24734 7.28Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33984 10C9.69984 9.925 10.0398 9.78 10.3198 9.565C11.0998 8.98 11.0998 8.015 10.3198 7.43C10.0448 7.22 9.70984 7.08 9.35484 7",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewleads);
export default __webpack_public_path__ + "static/media/newleads.0d9a158996ba45db2d647fde3f63771d.svg";
export { ForwardRef as ReactComponent };